<template>
  <div class="about">
    <div class="wrap">
      <div class="text">
        <h1>
          Про нас
        </h1>
        <br>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quia soluta libero eveniet ipsam beatae, nostrum sint iure!
        </p>
        <a href="#">Contacts</a>
      </div>
      <hooper :wheelControl="false" class="slider">
        <slide class="slide slide1"></slide>
        <slide class="slide slide2"></slide>
        <slide class="slide slide3"></slide>
      </hooper>
    </div>
  </div>
</template>

<script>
  import { Hooper, Slide } from 'hooper';
  import 'hooper/dist/hooper.css';

  export default {
    name: 'About',
    components: {
      Hooper,
      Slide
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "../assets/styles/variables.scss";

  .about{
    width: 100%;
    position: relative;
    padding-top: 100px;
    padding-bottom: 100px;
    float: left;
    background-color: rgba(0, 0, 0, .5);

    @media screen and (max-width: 768px) {
      width: 100%;
      overflow: hidden;
      position: relative;
      width: 100%;
      padding-top: 30px;
      padding-bottom: 30px;
    }

    .wrap{
      position: relative;
    }

    .text{
      width: 40%;
      height: 350px;
      position: relative;
      left: 0;
      display: -webkit-flex;
      display: -moz-flex;
      display: -ms-flex;
      display: -o-flex;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      justify-content: center;
      float: left;

      @media screen and (max-width: 768px) {
        width: 100%;
        align-items: center;
      }

      h1{
        display: inline-block;
        text-align: right;
        border-bottom: 2px solid $accentColor;
        height: 62px;
        font-weight: 400;

        @media screen and (max-width: 768px) {
          text-align: center;
        }
      }

      p{
        display: inline-block;
        text-align: right;
        margin-top: 20px;

        @media screen and (max-width: 768px) {
          margin-top: 20px;
          text-align: center;
        }
      }

      a{
        color: #fff;
        font-size: 17px;
        margin-top: 20px;
        padding: 7px 20px;
        border: 2px solid $accentColor;
        text-decoration: none;
        transition: 0.2s;

        &:hover{
          padding: 7px 25px;
          transition: 0.6s;
        }

        @media screen and (max-width: 768px) {
          margin-top: 10px;
        }
      }
    }
    
    .slider{
      width: 50%;
      position: relative;
      right: 0;
      height: 350px;
      background-color: #f7f7f7;
      float: right;

      .slide{
        width: 100%;
        height: 350px;
        background-position: center center;
        -webkit-background-size: cover;
        background-size: cover;
        background-repeat: no-repeat;
      }

      /*<!-- Slider sides bg -->*/
      .slide1{
        background-image: url(../assets/img/igor-miske-287430-unsplash.min.jpg);
      }

      .slide2{
        background-image: url(../assets/img/louis-hansel-1446167-unsplash.min.jpg);
      }

      .slide3{
        background-image: url(../assets/img/zac-cain-610365-unsplash.min.jpg);
      }


      @media screen and (max-width: 768px) {
        overflow: hidden;
        position: relative;
        width: 100%;
      }
    }
  }
</style>
